<template>
  <Toaster rich-colors close-button :theme />
  <VersionUpdateToast />
  <RouterView />
</template>

<script setup lang="ts">
import VersionUpdateToast from '@/components/VersionUpdateToast'
import { Toaster } from '@/components/ui/sonner'
import { useSystemStore } from '@/stores/system'
import { useVersionUpdateStore } from '@/stores/versionUpdate'
import { useDark } from '@vueuse/core'
import { computed, onMounted, watch } from 'vue'
import 'vue-sonner/style.css'

const systemStore = useSystemStore()
const versionUpdateStore = useVersionUpdateStore()

const isDark = useDark()

const theme = computed(() => (isDark.value ? 'dark' : 'light'))
const hasError = computed(() => systemStore.hasError())

// Clear errors from system store (toast is shown by useAsync hook)
watch(hasError, (newVal) => {
  if (newVal) {
    systemStore.clearError()
  }
})

onMounted(() => versionUpdateStore.init())
</script>
